import { render, staticRenderFns } from "./DiagnosenRoot.vue?vue&type=template&id=715c6e00&scoped=true"
import script from "./DiagnosenRoot.vue?vue&type=script&lang=js"
export * from "./DiagnosenRoot.vue?vue&type=script&lang=js"
import style0 from "./DiagnosenRoot.vue?vue&type=style&index=0&id=715c6e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715c6e00",
  null
  
)

export default component.exports